import React, { Component } from "react";

class Clicker extends Component {
  state = {
    //Data needed for this component to work well
    count: 0,
  };

  //Helper Methods
  incrementCount = () => {
    this.setState((prevState) => ({ count: prevState.count + 1 }));
  };

  decrementCount = () => {
    this.setState((prevState) => ({ count: prevState.count - 1 }));
  };

  resetCount = () => {
    this.setState(() => ({ count: 0 }));
    console.log("The reset button was just clicked!!!");
  };

  render() {
    return (
      <div className="container">
        <div className="clicker rounded">
          <div className="clicker-display d-flex align-items-center bg-info text-white">
            <div className="mx-auto display-1">{this.state.count}</div>
          </div>
          <div className="clicker-control-buttons d-flex">
            <button
              className="btn btn-success w-100 p-3"
              onClick={this.incrementCount}
            >
              {" "}
              <i className="fa fa-plus fa-2x"></i>
            </button>
            <button
              className="btn btn-warning w-100 p-3"
              onClick={this.resetCount}
            >
              <i className="fa fa-refresh fa-2x"></i>
            </button>
            <button
              className="btn btn-danger w-100 p-3"
              onClick={this.decrementCount}
            >
              <i className="fa fa-minus fa-2x"></i>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Clicker;
